<template>
  <q-page class="container" padding>
    <PageHeader
      title="Associar Checklist / Itens"
      :backRoute="{ name: 'home' }"
      backBehavior="route"
    />

    <div>
      <lista-unidades-select
        class="row col-3"
        v-model="unidade"
      ></lista-unidades-select>
    </div>
    <div class="row q-mt-md">
      <FerramentaUnicaVale @selectValue="getFerramenta" :atualizar="refresh" />

      <TableAssociarChecklistVale
        @usuariosSelecionados="getUsuarios"
        @userDesvincularId="getUserEspecifico"
        :atualizar="ferramenta"
      />
    </div>
    <q-tabs
      v-model="tab"
      dense
      class="text-grey bg-grey-3 q-mt-xl"
      active-color="primary"
      indicator-color="primary"
      align="justify"
      narrow-indicator
    >
      <q-tab name="selecionadas" label="Selecionadas" />
      <q-tab name="associadas" label="Associadas" />
    </q-tabs>
    <q-tab-panels v-model="tab" animated>
      <q-tab-panel name="selecionadas">
        <div>
          <q-table
            flat
            table-header-class="bg-accent text-width-bold"
            class="q-mt-sm tabela-tamanho-fixo"
            :rows="usuariosSelecionados"
            :columns="columns"
            :loading="disable"
            dense
            :rows-per-page-options="[0]"
            hide-bottom
            row-key="id"
            no-data-label
          >
            <template v-slot:bottom>
              <section class="row align">
                <div class="row">
                  <p class="text-h6 text-brand-5">Ferramentas Selecionadas</p>
                </div>
              </section>
            </template>
            <template v-slot:top>
              <section class="row align">
                <div class="row">
                  <p class="text-h6 text-brand-5">
                    Checklists Selecionados
                    <span v-if="ferramenta"
                      >- {{ ferramenta.nome }} - {{ ferramenta.patrimonio }}
                    </span>
                  </p>
                </div>
              </section>
            </template>
            <template #body-cell-remover="props">
              <q-td>
                <q-btn
                  size="sm"
                  color="red"
                  icon="delete"
                  label="Remover"
                  no-caps
                  @click="remover(props)"
                />
              </q-td>
            </template>
          </q-table>
          <div class="row justify-end">
            <q-btn
              size="md"
              class="q-mt-lg"
              color="positive"
              label="Associar"
              no-caps
              icon="check_circle_outlined"
              @click="Assosiar(props)"
            />
          </div>
        </div>
      </q-tab-panel>

      <q-tab-panel name="associadas">
        <div>
          <q-table
            flat
            table-header-class="bg-accent text-width-bold"
            class="q-mt-sm tabela-tamanho-fixo"
            :rows="ferramentasVinculadas"
            :columns="columns2"
            dense
            :loading="disable"
            :rows-per-page-options="[0]"
            hide-bottom
            row-key="id"
            no-data-label
          >
            <template v-slot:top>
              <section class="row align">
                <div class="row">
                  <p class="text-h6 text-brand-5">
                    Checklists Associados ao item
                  </p>
                </div>
              </section>
            </template>
            <template #body-cell-remover="props">
              <q-td>
                <q-btn
                  size="sm"
                  color="red"
                  icon="delete"
                  label="Remover Associação"
                  no-caps
                  @click="desvincular(props.row.uuid)"
                />
              </q-td>
            </template>
          </q-table>
        </div>
      </q-tab-panel>
    </q-tab-panels>
  </q-page>
</template>

<script>
const columns = [
  {
    name: "remover",
    label: "Remover",
    field: "remover",
    align: "left",
  },

  {
    name: "descricao",
    label: "Verificações",
    field: "descricao",
    align: "left",
  },
];

const columns2 = [
  {
    name: "descricao",
    label: "Vinculados",
    field: "descricao",
    align: "left",
  },

  {
    name: "remover",
    label: "Desfazer Associação",
    field: "remover",
    align: "left",
  },
];

import FerramentaUnicaVale from "../components/TableFerramentaUnicaVale.vue";

import { ref, watch, onMounted } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";

import TableAssociarChecklistVale from "../components/TableAssociarChecklistVale.vue";
import ListaUnidadesSelect from "../../organizacional/unidade/component/ListaUnidadesSelect.vue";
import PageHeader from "../../../components/PageHeader.vue";

export default {
  components: {
    FerramentaUnicaVale,

    TableAssociarChecklistVale,
    ListaUnidadesSelect,
    PageHeader,
  },
  setup() {
    const $q = useQuasar();
    const store = useStore();
    const ferramenta = ref("");
    const usuariosSelecionados = ref([]);
    const ferramentasVinculadas = ref([]);
    const refresh = ref(0);
    let unidade = ref("");
    const disable = ref(false);

    const tab = ref("selecionadas");
    const userDesvincularId = ref("");

    const getFerramenta = async (value) => {
      if (value) {
        ferramenta.value = await value[0];
      }
      console.log(ferramenta.value);
      if (
        ferramenta.value?.checkListObj?.length != 0 &&
        ferramenta.value != undefined
      ) {
        ferramentasVinculadas.value = ferramenta.value.checkListObj;
      }
    };

    const getUsuarios = async (usuario) => {
      usuariosSelecionados.value = usuario;
    };

    const getUserEspecifico = async (value) => {
      userDesvincularId.value = value;
    };

    const remover = async (dados) => {
      usuariosSelecionados.value.splice(dados.rowIndex, 1);
    };

    const desvincular = async (idCheklist) => {
      let checkArray = [];
      checkArray.push({ check_list_uuid: idCheklist });
      try {
        await store.dispatch("fer/RemoverChecklist", {
          check_lists: checkArray,
          check_uuid: ferramenta.value.uuid,
        });
        $q.notify({
          message: "item Desvinculado com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });

        let retornoId = ferramentasVinculadas.value.findIndex((e) => {
          return e.uuid == idCheklist;
        });

        ferramentasVinculadas.value.splice(retornoId, 1);
      } catch (error) {
        $q.notify({
          message: "Erro a o desvincular item",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const Assosiar = async () => {
      try {
        usuariosSelecionados.value.forEach(async (e) => {
          let vincular = [{ check_list_uuid: e.uuid }];

          await store.dispatch("fer/AssosiarChecklist", {
            check_lists: vincular,
            check_uuid: ferramenta.value.uuid,
          });
        });

        $q.notify({
          message: "item Associado com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });

        while (usuariosSelecionados.value.length) {
          usuariosSelecionados.value.pop();
        }

        refresh.value++;
      } catch (error) {
        $q.notify({
          message: "Erro ao Associar item",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }

      refresh.value++;
    };

    const getUnidadee = () => {
      if (
        localStorage.unidade &&
        localStorage.unidade != null &&
        localStorage.unidade != "null"
      ) {
        let getunidade = localStorage.getItem("unidade");
        unidade.value = JSON.parse(getunidade);
      }
    };

    watch(
      () => store.state.org.unidadeData,
      () => {
        if (store.state.org.unidadeData == null) {
          return;
        }
        unidade.value = store.state.org.unidadeData;
        refresh.value++;
      }
    );

    onMounted(getUnidadee);

    return {
      getFerramenta,
      getUsuarios,
      usuariosSelecionados,
      columns,
      remover,
      ferramenta,
      ferramentasVinculadas,
      columns2,
      desvincular,
      Assosiar,
      refresh,
      tab,
      unidade,
      disable,
      userDesvincularId,
      getUserEspecifico,
    };
  },
};
</script>

<style scoped>
a {
  text-decoration: none;
}
</style>
